import { useLocalSearchParams } from 'expo-router';
import React from 'react';

import BlogPage from '@/components/md-blog/blog-page';

// @ts-ignore
const mdxctx = require.context('../../../../articles', true, /\.(mdx|js)$/);

export async function generateStaticParams(): Promise<{ post: string }[]> {
  return mdxctx
    .keys()
    .filter((i: string) => i.match(/\.js$/))
    .map((key: string) => mdxctx(key).slug)
    .map((post: string) => ({ post }));
}

export default function Page() {
  const { post: postId } = useLocalSearchParams<{ post: string }>();

  return <BlogPage mdxctx={mdxctx} postId={postId} />;
}
